<template>
  <div id="login" class="wp-login">
    <form @submit.prevent="login" class="form-default">
      <img class="logo-pos" src="assets/img/logo-pos.png">
      <div style="text-align:center" v-if="token && salePointStations.length > 1">
        <h4 v-translate >Please choose your sale point</h4><br>
        <div v-for="station in salePointStations">
          <button class="btn btn-lg btn-primary" @click.prevent="pickStation(station.id)">
            <span>{{ printName(station.location, 'locations') }} - {{ station.name }}</span>
          </button><br></br>
        </div>
      </div>
      <div v-else >
        <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
        <div class="form-group form-group-icon">
          <input class="form-control form-control-lg" type="text" name="username" :placeholder="$gettext('ID / Username')" v-model="input.username"/>
        </div>
        <div class="form-group form-group-icon">
          <input class="form-control form-control-lg" type="password" :placeholder="$gettext('Password')" name="password" v-model="input.password"/>
        </div>
        <div class="form-footer">
          <div class="row">
            <div class="col-4">
              <select class="form-control mb-3 btn-lg language" @change="setLanguage" :value="$language.current">
                <option v-for="(language, key) in languageSelect" :key="key" :value="language.value">{{ language.text }}</option>
              </select>
            </div>
            <div class="col-6 offset-2">
              <button class="btn btn-lg btn-primary w-100" type="submit">
                <span v-translate>Log-in</span>
              </button>
            </div>
            <div class="col-12 text-center mt-3">
              <a href="#" class="form-footer-text">
                <icon name="fingerprint" />
                <span v-translate>Touch for log in</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService';
import SettingService from '@/services/SettingService';

export default {
  name: 'Login',
  data() {
    return {
      input: {
        username: '',
        password: '',
      },
      errorMessage: '',
    };
  },
  computed: {
    languageSelect() {
      const language = this.getArray('settings').find(lang => lang.name === 'language');
      let rs = [];
      const languages = [];
      if (language && language.value) {
        rs = language.value.split(',');
      }
      Object.keys(this.$language.available).forEach((key) => {
        if (rs.includes(key)) {
          languages.push({
            text: this.$language.available[key],
            value: key,
          });
        }
      });
      return languages;
    },
    token() { return this.getMap('token', true); },
    user() { return this.getMap('user', true); },
    salePointStations() {
      return this
        .getArray('stations', true)
        .filter(station => station.isSalePoint);
    },
  },
  watch: {
    salePointStations(value) {
      if (value.length == 1 && this.token) {
        this.$router.replace({ name: 'order' });
      }
    },
  },
  methods: {
    setLanguage(language) {
      this.$language.current = language.target.value;
      localStorage.setItem('pos-language', language.target.value);
    },
    login() {
      if (this.input.username !== '' && this.input.password !== '') {
        AuthService.login(this.input);
      } else {
        this.errorMessage = this.$gettext('A username and password must be present');
      }
    },
    async pickStation(station) {
      const response = await AuthService.pickStation(station);
      if (response) {
        this.user.station = this.getObject(station, 'stations');
        this.user.location = this.getObject(this.user.station.location, 'locations');
        this.user.workDay = response.workDay;
        if (response.shift) {
          this.user.shift = response.shift;
        }
        localStorage.setItem('pos_user', JSON.stringify(this.user));
        this.$router.replace({ name: 'order' });
      }
    },
  },
};
</script>
